function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaisedBedX24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2780",
    d: "M3 3h18v18H3z",
    style: {
      fill: "none",
      stroke: "#3e4346"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2781",
    d: "M5 5h14v14H5z",
    style: {
      fill: "#a75712"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisedBedX24);
export default __webpack_public_path__ + "static/media/raised-bed-x24.c6c09cd2edb7d1a70f3d280b6780c934.svg";
export { ForwardRef as ReactComponent };